namespace Solovis.UI.DomHelper {
    
    var getZIndexAsNumber = function (val) {
        if (val == "") {
            return 0;
        }
        else if (typeof val == "string") {
            return parseInt(val);
        }
        else {
            return val;
        }
    };    

    export function findMaxZIndexForElementChildren(element) {
        /// <summary>
        /// Finds highest z-index of any element directly within the body. This can be used to figure out
        /// z-index to place something directly above everything else.
        /// </summary>
        var maxZIndex = 0;
        $(element).children().each(function (i, childElement: any) {
            var childZIndexStr = childElement.style ? childElement.style.zIndex : null;
            var childZIndex = getZIndexAsNumber(childZIndexStr);
            if (childZIndex !== null && childZIndex > maxZIndex) {
                maxZIndex = childZIndex;
            }
        });
        
        return maxZIndex;
    };

    export function findZIndexOfTopLevelParent(element) {
        /// <summary>
        /// Finds z-index of the top level parent of element within the body. This can be used to figure out
        /// z-index to place something directly above a particular element.
        /// </summary>
        var node: any = $(element).get(0);
        if (node) {
            while (node.parentNode && node.parentNode.tagName != "BODY") {                
                node = node.parentNode;
            }

            if (node) {
                var zIndexStr = node.style.zIndex;
                var zIndex = getZIndexAsNumber(zIndexStr);
                return zIndex;
            }
        }

        return 0;
    };

    export function applyCssRules(domElement, cssRules) {
        for (var cssProperty in cssRules) {
            domElement.css(cssProperty, cssRules[cssProperty]);
        }
    };

    export function isDescendantOf(element, possibleParent) {
        /// <summary>
        /// Determine if element is a descendant of the parent.
        /// </summary>
        var desiredRoot = $(possibleParent).get(0);

        element = $(element);

        while (element && element.length > 0) {
            var actualElement = $(element).get(0);
            if (actualElement === desiredRoot) {
                return true;
            }

            element = element.parent();
        }

        return false;
    };

    export function hasMatchingParentOrSelf(element, matchCallback) {
        /// <summary>
        /// Determine if element or one of it's parents matches the function given.
        /// matchCallback(item) return true/false.
        /// </summary>
     
        element = $(element);

        while (element && element.length > 0) {
            var result = matchCallback(element);
            if (result) {
                return true;
            }

            element = element.parent();
        }

        return false;
    };


    /**
     * Returns all vertical scrollable containers for an element, which will include everything up to top-level of body plus window.
     */
    export function getVerticalScrollableContainers(element) {
        var scrollables = [];
 
        var current = $(element).parent();
        while (current && current.length) {
            var currentElement = current.get(0);

            if (currentElement !== document.body) {
                var overflowY = window.getComputedStyle(currentElement, null).getPropertyValue("overflow-y");
                if (overflowY === "auto") {
                    scrollables.push(currentElement);
                }

                current = current.parent();
            }
            else {
                current = null;
            }
        }

        scrollables.push(window);

        return scrollables;
    };

    /* Returns the first child control in the parentElement that matches the matchCallback */
    export function findFirstMatchingControl(parentElement, matchCallback) {
        var result = null;

        var controlMatchPredicate = function(element) {
            if (element.__controlHost &&
                element.__controlHost.currentControl &&
                matchCallback(element.__controlHost.currentControl)) {

                return true;
            }
            return false;
        };

        if (controlMatchPredicate(parentElement)) {
            return parentElement.__controlHost.currentControl;
        }
        else {
            result = DomHelper.findFirstMatchingElement(parentElement, controlMatchPredicate);

            if (result) {
                return result.__controlHost.currentControl;
            }
            return null;
        }
    };

    /* Returns the first child element in the parent element that matches the matchCallback*/
    export function findFirstMatchingElement(parentElement, matchCallback) {
        var result = null;

        if (parentElement && matchCallback(parentElement)) {
            return parentElement;
        }
        else {
            var children = $(parentElement).children();
            for (var i = 0; i < children.length; i++) {
                var currentChild = children[i];

                result = DomHelper.findFirstMatchingElement(currentChild, matchCallback);

                if (result) {
                    return result;
                }
            }

            return null;
        }
    }


    export function focusableClick(element, handler: () => void) {
        let $element = $(element);
        let tabindex = $element.attr("tabindex");
        if (Solovis.isNull(tabindex))
            $element.attr("tabindex", 0);

        $element.click(function (e) {
            e.preventDefault();
            handler.call(element);            
            return false;
        });
        $element.keydown(function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();                
                return false;
            }
        });
        $element.keyup(function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                handler.call(element);
                return false;
            }
        });
    }

    export function htmlEncode(str: any) {
        var textArea = document.createElement('textarea');
        textArea.innerText = str;
        return textArea.innerHTML;
    }
}